<template>
  <div class="container">
    <div class="label">{{ name }}</div>
    <DualUnit
      class="field"
      v-if="showDualUnit"
      :rightUnit="rightUnit"
      :leftUnit="leftUnit"
      :leftToRightConversion="leftToRightConversion"
      @valueChanged="dualUnitValueChanged"
    ></DualUnit>
    <TextField
      class="field"
      v-else
      :unit="leftUnit"
      :value="initialValue"
      :textAlign="textAlign"
      @input="singleUnitChanged"
    ></TextField>
  </div>
</template>

<script>
import TextField from './TextField.vue'
import DualUnit from './DualUnit.vue'

export default {
  name: 'LabelledInput',
  props: {
    textAlign: {
      default: 'right'
    },
    name: {
      default: 'No Name'
    },
    initialValue: {
      default: ''
    },
    leftToRightConversion: {
      default: 2
    },
    showDualUnit: {
      default: true
    },
    leftUnit: {
      default: ''
    },
    rightUnit: {
      default: 'cm'
    }
  },
  data() {
    return {}
  },
  methods: {
    singleUnitChanged(value) {
      this.$emit('valueChanged', value)
    },
    dualUnitValueChanged(leftValue, rightValue) {
      this.$emit('valueChanged', leftValue)
    }
  },
  components: {
    TextField,
    DualUnit
  }
}
</script>

<style scoped>
.container {
  display: grid;
  grid-template-rows: 50% 50%;
  box-sizing: border-box;
}
.label {
  color: black;
  grid-row: 1;
  text-align: left;
}
.field {
  grid-row: 2;
}
</style>
